<app-container>
    <mat-card class="card-body p-0">
        <iframe src="https://share.hsforms.com/18iAgULoBRBWXzganXkbjwQcpfw0" frameborder="0" 
        style="overflow:hidden;width:100%" width="100%"></iframe>
    </mat-card>
</app-container>